<template>
    <div class="my-step">
        <dl class="my-step__msg">
            <dt>颁奖</dt>
            <dd v-if="isBefore(finalRes)">将于{{awardTime|time2text('M月D日')}}开始颁奖</dd>
            <dd v-else-if="myAwards">
                你在比赛中获得了: 
                <span v-for="award in myAwards" :key="award.keyName">
                    <br><span class="red">{{award.name}}</span>
                </span>
            </dd>
            <dd v-else>
                {{awardTime|time2text('M月D日')}}开始颁奖
            </dd>
        </dl>

        <div class="my-step__btn">
            <router-link v-if="isAfter(finalRes)" class="active" tag="a" to="/match/my/awards">我的奖项</router-link>
        </div>
    </div>
</template>

<script>
    import {
        mapState,
        mapGetters,
        mapActions
    } from 'vuex'
    export default {
        name: 'my-step-award',
        computed: {
            ...mapState(['myAwards']),
            ...mapGetters(['nowTime', 'isBefore', 'isAfter', 'signBegin', 'preBegin', 'preEnd', 'preRes', 'finalBegin',
                'finalEnd',
                'finalRes',
                'awardTime', 'finishCupNum', 'allCupNum',
                'isAdvance', 'isFinishFinal',
                'preRank', 'preScore', 'finalRank', 'finalScore', 'maxAvgScore'
            ])
        },
        methods: {
            ...mapActions(['goPrePlay'])
        }
    };

</script>
